<template>
  <b-card-text>
    <div class="d-flex justify-content-between">
      <h5>Дополнительное соглашение № 1</h5>
      <b-button
        @click="predprosmotr = !predprosmotr"
      >
        Предпросмотр
      </b-button>
    </div>

    <div v-if="predprosmotr" class="predprosmotr-card">
      <p class="text-center">Дополнительное соглашение № 1 к договору № {{ docHistory['typ_dog'].number_of_dogovor || '_____' }} от «{{ docHistory['typ_dog'].day_of_dogovor || '____' }}» {{ docHistory['typ_dog'].month_of_dogovor || '_______________' }} {{ docHistory['typ_dog'].year_of_dogovor || '2025' }} г.<br>на оказание услуг таможенного представителя</p>
      <div class="d-flex justify-content-between mb-3">
        <div>г. Москва</div>
        <div class="text-right">«{{ docHistory['typ_dog'].day_of_add_app || '____' }}» {{ docHistory['typ_dog'].month_of_add_app || '_______________' }} {{ docHistory['typ_dog'].year_of_add_app || '2025' }} г.</div>
      </div>
      <p class="text-justify">&emsp;&emsp;&emsp;&emsp;{{ docHistory['typ_dog'].full_pravovaya_form }} {{ docHistory['typ_dog'].full_pravovaya_form === 'Индивидуальный предприниматель' ? docHistory['typ_dog'].full_org_name_not_caps : ('«' + docHistory['typ_dog'].full_org_name + '»') }}, {{ docHistory['typ_dog'].full_pravovaya_form === 'Индивидуальный предприниматель' ? 'именуемый' : 'именуемое' }} в дальнейшем «Клиент», в лице {{ docHistory['typ_dog'].in_face_of_org }} {{ docHistory['typ_dog'].fio_of_face_of_org }}, действующего на основании {{ docHistory['typ_dog'].is_ustav }}{{ docHistory['typ_dog'].is_ustav === 'ОГРНИП' ? (' ' + docHistory['typ_dog'].ogrn_of_org) : '' }}, с одной стороны и Общество с ограниченной ответственностью «ТАНАИС Брокер», именуемое в дальнейшем «Представитель», в лице генерального директора Бородиной Елены Эдуардовны, действующей на основании Устава, с другой стороны, совместно именуемые в дальнейшем «Стороны», заключили настоящий договор (далее - «Договор») о нижеследующем:</p>
      <p>----------------</p>

      <p>&emsp;&emsp;&emsp;&emsp;1.1</p>
      <b-table-simple small responsive bordered>
        <b-tbody>
          <b-tr>
            <b-td class="text-center font-weight-bold">№</b-td>
            <b-td class="text-center font-weight-bold">Наименование услуги</b-td>
            <b-td class="text-center font-weight-bold">Ед.изм.</b-td>
            <b-td colspan="2" class="text-center font-weight-bold">Ставка, руб.<br>В т.ч. НДС</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">1</b-td>
            <b-td class="text-left">Таможенное оформление грузов, прибывающих в {{ docHistory['typ_dog'].arrived_adress_ground  || '***' }}</b-td>
            <b-td class="text-center">трансп.<br>средство</b-td>
            <b-td class="text-center">Оформление ДТ до 7<br>кодов</b-td>
            <b-td class="text-center">{{ docHistory['typ_dog'].arrived_adress_ground_cost || '***' }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <p>----------------</p>

      <b-table-simple small responsive bordered>
        <b-tbody>
          <b-tr>
            <b-td class="text-center font-weight-bold">№</b-td>
            <b-td class="text-center font-weight-bold">Наименование услуги</b-td>
            <b-td class="text-center font-weight-bold">Ед.изм.</b-td>
            <b-td colspan="2" class="text-center font-weight-bold">Ставка, руб.<br>В т.ч. НДС</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">1</b-td>
            <b-td class="text-left">Таможенное оформление грузов, прибывающих в аэропорт/-ы {{ docHistory['typ_dog'].arrived_adress_avia || '***' }}</b-td>
            <b-td class="text-center">авиа.накл.</b-td>
            <b-td class="text-center">Оформление ДТ до 7<br>кодов</b-td>
            <b-td class="text-center">{{ docHistory['typ_dog'].arrived_adress_avia_cost || '***' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">2</b-td>
            <b-td class="text-left">Таможенное оформление грузов, прибывающих в {{ docHistory['typ_dog'].arrived_adress_ground || '***' }}</b-td>
            <b-td class="text-center">трансп.<br>средство</b-td>
            <b-td class="text-center">Оформление ДТ до 7<br>кодов</b-td>
            <b-td class="text-center">{{ docHistory['typ_dog'].arrived_adress_ground_cost || '***' }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <p>----------------</p>

      <p>&emsp;&emsp;&emsp;&emsp;2. 2. Контакты по Договору </p>
      <b-table-simple small responsive bordered>
        <b-tbody>
          <b-tr>
            <b-td colspan="3" class="text-center">со стороны Клиента</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-left">Бухгалтерия</b-td>
            <b-td class="text-center">{{ docHistory['typ_dog'].tel_of_buhgalter || '8(495)123-45-67' }}</b-td>
            <b-td class="text-center">{{ docHistory['typ_dog'].email_of_buhgalter || 'mail@mail.ru' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-left">адрес для отправки корреспонденции курьером или экспресс почтой:</b-td>
            <b-td colspan="2" class="text-center">{{ docHistory['typ_dog'].post_adress_for_korresp || '***' }}</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-left">адрес для отправки корреспонденции почтой России:</b-td>
            <b-td colspan="2" class="text-center">{{ docHistory['typ_dog'].post_adress_for_main_post || '***' }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <b-row class="my-2">
      <b-col cols="3">
        <label class="small-label">Число доп. приложения:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].day_of_add_app"
          size="sm"
          trim
          type="number"
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Месяц доп. приложения:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].month_of_add_app"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Год доп. приложения:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].year_of_add_app"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <label class="small-label">Адрес для грузов прибывающих <br>на транспортном средстве:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].arrived_adress_ground"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Ставка, руб., в т.ч. НДС, транс.средство:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].arrived_adress_ground_cost"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <label class="small-label">Адрес для грузов прибывающих <br>в аэропорт/-ы:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].arrived_adress_avia"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Ставка, руб., в т.ч. НДС, авиа.накл.:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].arrived_adress_avia_cost"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col cols="6">
        <label class="small-label">Телефон бухгалтерии:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].tel_of_buhgalter"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="6">
        <label class="small-label">E-mail бухгалтерии:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].email_of_buhgalter"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <label class="small-label">Адрес для отправки корреспонденции курьером или экспресс почтой:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].post_adress_for_korresp"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col>
        <label class="small-label">Адрес для отправки корреспонденции почтой России:</label>
        <b-form-input
          v-model="docHistory['typ_dog'].post_adress_for_main_post"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
  </b-card-text>
</template>

<script>
export default {
  data() {
    return {
      predprosmotr: false,
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  .small-label {
    font-size: 12px;
  }

  .predprosmotr-card {
    padding: 15px;
    margin: 20px 0;
    background: #cccccc59;
  }
</style>